function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.76.69h.037c.55.022 1.081.523 1.098 1.273v.051l.005.038.642 5.81.054.488.478.11.275.062h.001l.143.034.299.069v.001l.028.006c1.374.314 3.157.721 6.3 2.752.06.388.227 1.608.183 3.068-.053 1.75-.414 3.711-1.426 5.06-.889 1.18-2.146 1.798-3.944 1.798h-.068c-2.753-.025-5.487-1.891-7.626-3.976a28.369 28.369 0 0 1-3.471-4.13c.484-.513.993-.722 1.506-.722.44 0 .884.167 1.262.378.372.208.624.428.659.46l.138.13.185.04.834.184.802.176.035-.82.324-7.5v-.008l.111-3.537v-.004c.02-.81.567-1.29 1.137-1.29z",
  stroke: "currentColor",
  strokeWidth: 2
});

const SvgHand = props => React.createElement("svg", _extends({
  viewBox: "0 0 18 22",
  fill: "none"
}, props), _ref);

export default SvgHand;